'use client'

import { ThemeProvider as NextThemesProvider } from 'next-themes'
import type { ReactNode } from 'react'

interface ThemeProviderProps {
  children: ReactNode
  /**
   * CSP nonce for next-themes' hand-authored theme-flash-prevention inline
   * `<script>`. Sourced server-side (RootLayout reads the `x-nonce` request
   * header set by src/proxy.ts) and passed down as a plain string prop —
   * this component stays `'use client'` for next-themes' client-side theme
   * detection/switching APIs, but the nonce itself must originate from the
   * server since client components have no access to the incoming request.
   * See issue #10753.
   */
  nonce?: string
}

export function ThemeProvider({ children, nonce }: ThemeProviderProps) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      nonce={nonce}
    >
      {children}
    </NextThemesProvider>
  )
}
